import React from 'react';
import { Box, Button } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Select from 'src/components/Select';
import { Option, OptionValue } from 'src/components/SelectOption/types';

export interface FilterState {
  search: string;
  type: string;
  gpu: string;
  useCase: string;
}

interface Props {
  filters: FilterState;
  useCases: string[];
  onChange: (f: FilterState) => void;
  onClear: () => void;
}

const TYPE_OPTIONS: Option[] = [
  { value: 'physical', label: 'Physical' },
  { value: 'vm', label: 'Virtual machine' },
];

const GPU_OPTIONS: Option[] = [
  { value: 'gpu', label: 'GPU enabled' },
  { value: 'none', label: 'No GPU' },
];

export default function InfraFilters({
  filters,
  useCases,
  onChange,
  onClear,
}: Props) {
  const useCaseOptions: Option[] = useCases.map((u) => ({
    value: u.toLowerCase(),
    label: u,
  }));

  const setSearch = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ ...filters, search: e.target.value });

  const set =
    (key: Exclude<keyof FilterState, 'search'>) =>
    (e: SelectChangeEvent<OptionValue | OptionValue[]>) =>
      onChange({ ...filters, [key]: String(e.target.value) });

  return (
    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', mb: 2 }}>
      <TextField
        size="small"
        placeholder="Search server or site…"
        value={filters.search}
        onChange={setSearch}
        sx={{ flex: 1 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="primary" fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      <Select
        label="Type"
        value={filters.type}
        onChange={set('type')}
        options={TYPE_OPTIONS}
        sx={{ minWidth: 160 }}
      />
      <Select
        label="GPU"
        value={filters.gpu}
        onChange={set('gpu')}
        options={GPU_OPTIONS}
        sx={{ minWidth: 160 }}
      />
      <Select
        label="Use case"
        value={filters.useCase}
        onChange={set('useCase')}
        options={useCaseOptions}
        sx={{ minWidth: 200 }}
      />
      <Button variant="outlined" onClick={onClear}>
        Clear
      </Button>
    </Box>
  );
}
